import { render, staticRenderFns } from "./Argument.vue?vue&type=template&id=c88f89b2"
import script from "./Argument.vue?vue&type=script&lang=js"
export * from "./Argument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports